module.exports = __webpack_public_path__ + "img/minimize.48cb7923.svg";